export const getCourseVoiceEntries = (course = {}) =>
  [
    ...new Set([
      ...(course.voices || []),
      ...Object.keys(course.voiceCharacters || {}),
    ]),
  ].map((name) => [
    name,
    {
      ...course.voiceCharacters?.[name],
      characterUrl: course.voiceCharacters?.[name]?.character?.characterUrl,
      characterName: course.voiceCharacters?.[name]?.character?.displayName,
      characterColor:
        course.voiceCharacters?.[name]?.characterColor ||
        course.defaultColor ||
        "#61FE6F",
    },
  ]);
